<template>
  <div class="container">
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          <fai icon="user"/>&nbsp;Nueva Comisión
        </div>
      </div>
      <div class="card-body pb-5">
        <!--begin: Comision Create -->
          <sys-form :inputs.sync="comision_create"/>
        <!--end: Comision Create -->
      </div>
      <div class="card-footer text-right">
        <button class="btn btn-secondary" @click="$router.go(-1)">
          <fai icon="reply"/> Cancelar
        </button>
        <button class="btn btn-success" @click="saveForm">
          <fai :icon="['far','edit']"/> Guardar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import promotersService from '@/services/promoters'
import SysForm from '@/components/shared/Form'
import formMixin from '@/mixins/form'

export default {
  name: 'ComisionCreate',

  components: { SysForm },

  mixins: [ formMixin ],

  data () {
    return {
      comision_create: {
        date_init: {
          name: 'Fecha desde',
          hint: 'Inicio del Periodo',
          value: '',
          type: 'date',
          size: 4,
          validate: 'required'
        },
        date_end: {
          name: 'Fecha hasta',
          hint: 'Fin del Periodo',
          value: '',
          type: 'date',
          size: 4,
          validate: 'required'
        }
      }
    }
  },
  methods: {
    saveForm: function () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          let promoterId = this.$route.params.id
          let body = this.processForm(this.comision_create)
          body['promoter_id'] = promoterId
          let service = promotersService.postComision(body)

          this.sendForm(service).then(res => {
            if (res.error) {
              alert(res.error)
            } else {
              this.$router.push({ name: 'promoter', params: { id: promoterId } })
            }
          }).catch(err => {
            console.log(JSON.stringify(err.statusText))
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/promoters/comisions/ComisionCreate.vue